import { render } from "./EmptyStateModal.vue?vue&type=template&id=6203ab71"
import script from "./EmptyStateModal.js?vue&type=script&lang=js"
export * from "./EmptyStateModal.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__